export const DEFAULT_ITEM_VALUE = -1;

export const CREATED_FIELD = 'Created';

export const SORT_TYPE_ASCENDING = 'ascending';

export const SORT_TYPE_DESCENDING = 'descending';

export const COURSE_TITLE_FIELD = 'Title';

export const COURSE_CODE_FIELD = 'Code';

export const COURSE_ACTIVE_STATE_ID = 1;

export const COURSE_ARCHIVED_STATE_ID = 2;

export const PAGE_SIZE_S = 25;

export const PAGE_SIZE_M = 50;

export const PAGE_SIZE_L = 100;

export const activationType = Object.freeze({
    yes: 1,
    no: 2,
    timeSpan: 3
});

export const activatedType = Object.freeze({
    now: 1,
    atSpecificTime: 2
});

export const deactivatedType = Object.freeze({
    never: 1,
    atSpecificTime: 2
});

export const defaultFromHour = '08';
export const defaultToHour = '16';

export const activationValidationErrors = Object.freeze({
    invalidStartDate: 1,
    invalidStopDate: 2,
    startDateGreaterThanStopDate: 3
});
